import React, { Component, Fragment } from 'react';
import withAppLayout from '../components/appLayout';
import FAQs from '../components/rent/Faqs';
import { MainFormDiv } from '../components/rent/MainFromDiv';
import { RentReceipt } from '../components/rent/staticComponents';

class Rent extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      showReceipt: false,
      reciptData: {},
    };
  }

  public handleReceiptAppearance = () => {
    this.setState({
      showReceipt: true,
    });
  };

  public getReceiptData = (data: any) => {
    this.setState({
      reciptData: { ...this.state.reciptData, ...data },
    });
  };

  public render() {
    return (
      <Fragment>
        <MainFormDiv
          receiptAppear={this.handleReceiptAppearance}
          getReceiptData={this.getReceiptData}
        />
        <div id="results">
          {this.state.showReceipt ? (
            <RentReceipt data={this.state.reciptData} />
          ) : null}
        </div>
        <FAQs />
      </Fragment>
    );
  }
}

export default withAppLayout(
  {
    title: 'Rent Receipt Generator Online - House Rent Receipt',
    description:
      'Why to generate a rent receipt on Excel when you can visit ClearTax. Get rent receipt online in easy steps: Click >Fill receipt >Print',
    canonicalUrl: 'https://cleartax.in/save/rent',
    showSidebar: false,
  },
  Rent
);



// WEBPACK FOOTER //
// ./pages/rent-page.tsx